import {
  StaticFlags,
  StaticFlagsHookType,
} from 'src/common/hooks/useStaticFlags/StaticFlagsHook.types';
import getLaunchNotifications from 'src/common/hooks/useStaticFlags/utils/getLaunchNotifications';
import getBooleanFlags from 'src/common/hooks/useStaticFlags/utils/getBooleanFlags';
import { AppSubdomains } from 'src/types/common';
import { getSubdomain } from 'src/utils/domain/getSubdomain';

export const useStaticFlags: StaticFlagsHookType = () => {
  const subdomain = getSubdomain(AppSubdomains, AppSubdomains.Pari);
  const booleanFlags = getBooleanFlags(subdomain);

  return {
    ...booleanFlags,
    [StaticFlags.LaunchNotifications]: getLaunchNotifications(subdomain),
  };
};
